import React, { useState } from 'react';
import { ComplaintTypeMock, ComplaintStatusMock } from './mockData';
import Loader from "./Loader";
import Header from './Header';
import { API_BASE_URL, ComplaintAddAPIEndpoint, ComplaintGetAPIEndpoint, ComplaintStatusUpdateAPIEndpoint, NoticesUpdateAPIEndpoint, NoticesDeleteAPIEndpoint  } from '../constant';
import { useEffect } from 'react';
import "./css/paginationtable.css";

function Complaint() {
  const token = sessionStorage.getItem("JWTtoken");
  const [notices, setNotices] = useState([]);
  const [form, setForm] = useState({ title: "", desc: "", type:""  });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  



    const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 3; 

  const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentRecords = notices.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(notices.length / recordsPerPage);

const userType = sessionStorage.getItem("userType"); // or session
const isUserTypeAdmin = userType === "admin" ? true : false;
const userId = sessionStorage.getItem("userId"); // or session
const residentId = sessionStorage.getItem("residentId"); // or session 





  const fetchNotices = async () => {
      try {
        const apiURL = API_BASE_URL + ComplaintGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.status) {
          setNotices(data.data);
        } else {
          setError(data.message || "Failed to fetch complaints");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {  
    fetchNotices();
  }, []);



 const validate = () => {

  // Validation: Name, phone, and apartment must not be empty
    if (!form.title.trim() || !form.desc.trim() ) {
      alert("Title, Description and complaint type are required!");
      return; // Stop submission
    }
    return true;
 }



  const handleSubmit = async (e)  => {
    //alert(JSON.stringify(form));
    e.preventDefault();

    if (!validate()) return;

    if (editingId) {
      setNotices(notices.map(n => n.id === editingId ? { ...form, id: editingId } : n));
      setEditingId(null);


try {
        const updateApiURL = API_BASE_URL + NoticesUpdateAPIEndpoint;
        const payload = {
          ...form,                 // existing form fields
          id: editingId,
         createdby : isUserTypeAdmin ? userId : residentId,
         flatNo : residentId

        };

        alert(JSON.stringify(payload));
        return;
    const response = await fetch(updateApiURL,
      {
        method: "POST",
        headers: { 
          "Content-Type": "application/json", 
          "Authorization": `Bearer ${token}` },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();

    if (result.status) {
      alert("Complaint updated successfully");

      // 🔥 reload table with updated data
      fetchNotices();

    } else {
      alert(result.message);
    }
  } catch (err) {
    alert("Server error");
  }


    } else {
      try {
      const addApiURL = API_BASE_URL + ComplaintAddAPIEndpoint;      
      const payload = {
        ...form,
         createdby : isUserTypeAdmin ? userId : residentId,
         flatNo : residentId
      } 
      const response = await fetch(addApiURL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
          "Authorization": `Bearer ${token}`
        },        
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();
      if (result.status) 
      {
          alert("Complaint added successfully.");
          setForm({
            title: "",
            desc: "",
            type : ""
          });
          fetchNotices(); // Refresh the notices list
      } 
      else 
      {
        alert(result.message);      
      }
    } 
    catch (error) 
    {
      alert("Server error".error);
    } 
  
  }
    setForm({ title: "", desc: "", type:"", status: "" });
  };

  const handleEdit = (n) => {
    setForm({ title: n.title, desc: n.desc, status: n.status, type: n.type });
    setEditingId(n.id);
  };

  const handleUpdate= async (data) => {
    setLoading(true);
     setEditingId(data.id);
    const payload = { id : data.id, 
        currentComplaintStatus : data.status,
        updatedby : isUserTypeAdmin ? 0 : residentId

    }; 
     //alert(JSON.stringify(payload));
    const updateStatusApiURL = API_BASE_URL + ComplaintStatusUpdateAPIEndpoint; 
    try{
          const response = await  fetch(updateStatusApiURL,
          {
            method: "POST",
             headers: {
              "Content-Type": "application/json", 
              "Authorization": `Bearer ${token}`
            },  
            body: JSON.stringify(payload)
          }
        );
        const result = await response.json();
        if(result.status)
        {
          alert("Complaint status updated successfully");
          await fetchNotices(); // Refresh the notices list
          setLoading(false);
        }
        else{
          alert(result.message);
          setLoading(false);
        }
    }catch(err){
       alert("Server error" .error);       
       setLoading(false);
    }    

  }


  const handleChange = (id, value) => {
  setNotices(prev =>
    prev.map(row =>
      row.id === id ? { ...row, status: value } : row
    )
  );
};


  const handleDelete = async (noticeId) => 
    {
      try {
        const deleteApiURL = API_BASE_URL + NoticesDeleteAPIEndpoint;
        const payload = { id : noticeId}; 
        const response = await  fetch(deleteApiURL,
          {
            method: "Delete",
             headers: {
              "Content-Type": "application/json", 
              "Authorization": `Bearer ${token}`
            },  
            body: JSON.stringify(payload)
          }
        );
        const result = await response.json();
        

        if (result.status) {
          alert("Complaint deleted successfully");
          await fetchNotices(); // Refresh the notices list

        } else {
          alert(result.message);
        }
      }
      catch (error) {
        alert("Server error".error);
      }
    };

  return ( <>
  <Header/>
    <div>
      <h1>Complaints</h1>
      {
        <div> 
            <input placeholder="Title" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}/>
            <textarea rows="1" placeholder="Description" value={form.desc} onChange={e => setForm({ ...form, desc: e.target.value })}/>
            <select  value={form.type} onChange={e => setForm({ ...form, type : e.target.value })}>
                <option value="">Select Type</option>
                {ComplaintTypeMock.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
            </select>
            { !isUserTypeAdmin && editingId 
            && <select  value={form.status} onChange={e => setForm({ ...form, status : e.target.value })}>
                <option value="">Select Status</option>
                {ComplaintStatusMock.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
            </select> }
            <button onClick={handleSubmit}>{editingId ? "Update" : "Add"} Complaint</button>
        </div>
      }
      {loading && <Loader/>}

<div className="table-container">
      <table style={{ border:"1px solid", width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "burlywood" }}>
            <th>Title</th>
            <th>Description</th>
            <th> Complaint Type </th>
            <th>Complaint Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {             
          currentRecords.length > 0 ? (
          currentRecords.map( (n, index) => {
            return (<tr  key={n.id} className={index % 2 === 0 ? "even" : "odd" } >
              <td>{n.title}</td>
              <td>{n.desc}</td>
              <td>{n.type}</td>
              {!isUserTypeAdmin && <td> {n.status} </td>}
              { isUserTypeAdmin && <td>
                    <select  value={String(n.status)}  onChange={e => handleChange(n.id, e.target.value)}  >
                        <option value="">Select Status</option>
                        {ComplaintStatusMock.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
                    </select>
               </td>}
              
              <td> {!isUserTypeAdmin && <button onClick={() => handleEdit(n)}>Edit</button>} {isUserTypeAdmin && <button onClick={() => handleUpdate(n)}>Update</button>} {isUserTypeAdmin && <button onClick={() => handleDelete(n.id)}>Delete</button>}</td>
            </tr>
)})) :    (
            <tr>
              <td colSpan="5" align="center">No records found</td>
            </tr>
          )
          
        }
        </tbody>
      </table>
</div>

       <div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> {indexOfFirst + 1} to {notices.length < indexOfLast ? notices.length : indexOfLast} of Total Record {notices.length} 
</div>
    </div>

    {/*<Pagination recordCount={notices.length} currentWorkingPage={currentPage} setCurrentWorkingPage={currentPage}  />*/}


    </>
  );
}

export default Complaint;
